import { ContentWithAside } from "layouts/kiosk-h"
import { EMBenchasiriKioskHPage } from "./pages/em-benchasiri-park/index.kiosk"
import { themeOptionFactories } from "./theme"
import { EMBenchasiriMobilePage } from "./pages/em-benchasiri-park"

export const emBenchasiriPark = {
  themeOptionFactories,
  ignoreAppThemeFactory: false,
  routes: {
    mobile: [
      {
        path: "benchasiri-park",
        element: <EMBenchasiriMobilePage />,
      },
    ],
    "kiosk-v": [],
    "kiosk-h": [
      {
        path: "benchasiri-park",
        element: <EMBenchasiriKioskHPage Layout={ContentWithAside} />,
      },
    ],
  },
}
